export enum DepositButtonActionType {

    Kyc = 1,
    Inappropriate = 2,
    Deposit = 3,
    Authorization = 4,
}
